<template>  
  <div class="evento-wrapper" ref="wrapperRef">

    <!-- Fondo -->
    <img
      :src="require('@/assets/F1.jpg')"
      alt="Fondo"
      class="fondo-textura"
    />

    <!-- Ramita decorativa -->
    <img
      src="@/assets/ramita.avif"
      alt="Decoración"
      class="ramita-fondo-visual"
    />

    <!-- TARJETA -->
    <div ref="ceremoniaRef" class="tarjeta-evento derecha">

      <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>

      <p ref="tituloRef" class="titulo-evento reveal">
        Mesa de Regalos
      </p>

      <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>

      <p ref="lugarRef" class="lugar reveal">
        Tu presencia es nuestro mejor<br>
        regalo, pero si quieres tener un<br>
        detalle con nosotros te damos la<br>
        sugerencia de:
      </p>

      <!-- SOBRE -->
      <div class="sobre-box reveal">

        <img
          src="@/assets/sobr.png"
          alt="Sobre"
          class="icono-sobre"
        />

      </div>

      <!-- TEXTO -->
      <p class="hora reveal">
        Lluvia de Sobres
      </p>
    <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>
      <!-- 🔥 CUENTA -->
      <div ref="cuentaRef" class="cuenta-box reveal">

        <img
          src="@/assets/tarjeta.png"
          alt="Sobre"
          class="icono-sobre"
        />
        <p class="hora reveal">
Banco BHD  <br>(República Dominicana)        </p>

        <p class="cuenta-numero">
          25412380021
        </p>

      </div>

 <br>      <br>  
      <!-- CONSIDERACIONES -->
      <div class="consideraciones-box reveal">
  <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>
        <p class="consideraciones-title">
             Consideraciones
        </p>

        <p class="consideraciones-text">
          Queremos que sea un día perfecto
          como lo hemos soñado, ayúdanos
          a hacerlo posible.
        </p>

        <div class="solo-adultos">
          — Solo adultos —
        </div>

      </div>
    <!-- HASHTAG -->
 
      <!-- NUESTRO AMOR -->
      <div class="amor-box reveal">

      
        <p class="amor-title">
     <br>      <br> Nuestro Amor
        </p>

        <div class="separator-holder mini">
          <img
            :src="require('@/assets/separadorr.png')"
            alt="Separador"
            class="separador-img"
          />
        </div>

        <p class="amor-text">
          No se mide en palabras, sino en
          momentos que elegimos compartir
          y este es uno muy especial.
          <br><br>
          Nos alegra poder vivirlo junto
          a quienes más queremos.
        </p>

      </div>

      <!-- CUENTA -->
      <div class="countdown-box reveal">

      <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>
        <p class="count-title">
          Nos vemos en:
        </p>

        <div class="count-grid">

          <div class="count-item">
            <span class="count-number">{{ days }}</span>
            <span class="count-label">Días</span>
          </div>

          <div class="count-item">
            <span class="count-number">{{ hours }}</span>
            <span class="count-label">Horas</span>
          </div>

          <div class="count-item">
            <span class="count-number">{{ minutes }}</span>
            <span class="count-label">Min</span>
          </div>

          <div class="count-item">
            <span class="count-number">{{ seconds }}</span>
            <span class="count-label">Seg</span>
          </div>

        </div>

      </div>
    <!-- FOTO -->
   
    </div>

  </div>
</template>
<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import gsap from 'gsap'

export default {

  name: 'EventoDoble',

  components: {
  },

  setup() {

    const wrapperRef = ref(null)

    const cuentaRef = ref(null)

    const days = ref('00')
    const hours = ref('00')
    const minutes = ref('00')
    const seconds = ref('00')

    // 🔥 MODIFICA AQUÍ LA FECHA
    const targetDate = new Date('2026-07-18T16:00:00')

    let timer = null
    let observer = null

    const updateCountdown = () => {

      const now = new Date().getTime()

      const distance = targetDate - now

      if (distance <= 0) {

        days.value = '00'
        hours.value = '00'
        minutes.value = '00'
        seconds.value = '00'

        return

      }

      days.value =
        String(
          Math.floor(
            distance / (1000 * 60 * 60 * 24)
          )
        ).padStart(2, '0')

      hours.value =
        String(
          Math.floor(
            (distance / (1000 * 60 * 60)) % 24
          )
        ).padStart(2, '0')

      minutes.value =
        String(
          Math.floor(
            (distance / (1000 * 60)) % 60
          )
        ).padStart(2, '0')

      seconds.value =
        String(
          Math.floor(
            (distance / 1000) % 60
          )
        ).padStart(2, '0')

    }

    onMounted(() => {

      updateCountdown()

      timer = setInterval(updateCountdown, 1000)

      const revealElements =
        wrapperRef.value.querySelectorAll('.reveal')

      observer =
        new IntersectionObserver((entries)=>{

          entries.forEach((entry)=>{

            if(entry.isIntersecting){

              entry.target.classList.add('visible')

              observer.unobserve(entry.target)

            }

          })

        }, {

          threshold:0.08

        })

      revealElements.forEach((el, index)=>{

        el.style.transitionDelay =
          `${index * 0.06}s`

        observer.observe(el)

      })

      /* 🔥 GSAP CUENTA */

      gsap.fromTo(
        cuentaRef.value,
        {
          opacity:0,
          y:40,
          scale:.8
        },
        {
          opacity:1,
          y:0,
          scale:1,
          duration:1.5,
          ease:'back.out(1.8)',
          scrollTrigger:{
            trigger:cuentaRef.value,
            start:'top 90%'
          }
        }
      )

      gsap.to(
        cuentaRef.value,
        {
          y:'-=8',
          duration:2.5,
          repeat:-1,
          yoyo:true,
          ease:'sine.inOut'
        }
      )

    })

    onBeforeUnmount(() => {

      clearInterval(timer)

      if(observer){

        observer.disconnect()

      }

    })

    return {

      wrapperRef,
      cuentaRef,

      days,
      hours,
      minutes,
      seconds

    }

  }

}
</script>
<style >

@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Poppins:wght@300;400;500&display=swap');

/* ========= CONTENEDOR ========= */

.evento-wrapper{
  position:relative;

  width:100%;

  min-height:100vh;

  padding:80px 20px;

  overflow:visible;

  display:flex;
  flex-direction:column;
  align-items:center;

  z-index:1;
}

/* ========= ANIMACIONES SOLO ESTE COMPONENTE ========= */

.evento-wrapper .reveal{

  opacity:0;

  transform:translateY(45px);

  transition:
  opacity .8s ease,
  transform .8s ease;

}

.evento-wrapper .reveal.visible{

  opacity:1;

  transform:translateY(0);

}

/* ========= FONDO ========= */

.fondo-textura{
  position:absolute;
  inset:0;

  width:100%;
  height:100%;

  object-fit:cover;

  z-index:0;
}

/* ========= RAMITA ========= */

.ramita-fondo-visual{
  position:absolute;
  top:-120px;
  left:0;

  width:100%;

  opacity:.05;

  z-index:1;

  pointer-events:none;
}

/* ========= TARJETA ========= */

.tarjeta-evento{
  position:relative;

  z-index:5;

  width:100%;
  max-width:390px;

  padding:20px 10px;

  text-align:center;
}

/* ========= TITULO ========= */

.titulo-evento{
  font-family:'Playfair Display', serif;

  font-size:38px;

  line-height:1.2;

  color:#b08a5a;

  margin-bottom:8px;
}

/* ========= TEXTO ========= */

.lugar{
  font-family:'Playfair Display', serif;

  font-size:21px;

  line-height:1.8;

  color:#6f6660;

  margin-top:10px;
}

/* ========= SOBRE ========= */

.sobre-box{
  margin-top:18px;

  display:flex;
  justify-content:center;
  align-items:center;
}

.icono-sobre{
  width:110px;

  height:auto;

  object-fit:contain;

  display:block;

  margin:0 auto;

  filter:
  drop-shadow(0 8px 16px rgba(0,0,0,.18));
}

/* ========= LLUVIA ========= */

.hora{
  margin-top:14px;

  font-family:'Playfair Display', serif;

  font-size:20px !important;

  color:#b08a5a;

  letter-spacing:.08em;
}

/* 🔥 CUENTA */

.cuenta-box{
  margin-top:-50px;
}

.cuenta-title{
  font-family:'Playfair Display', serif;
  font-size:26px;
  color:#b08a5a;
}

.cuenta-numero{
  margin-top:10px;

  font-family:'Poppins', sans-serif;

  font-size:22px;

  letter-spacing:.08em;

  color:#6f6660;
}

/* ========= CONSIDERACIONES ========= */

.consideraciones-box{
  margin-top:28px;
}

.consideraciones-title{
  font-family:'Playfair Display', serif;
  font-size:30px;
  color:#b08a5a;
}

.consideraciones-text{
  margin-top:10px;

  font-family:'Playfair Display', serif;
  font-size:20px;
  line-height:1.8;

  color:#6f6660;
}

.solo-adultos{
  margin-top:14px;

  font-family:'Playfair Display', serif;
  font-size:26px;

  color:#b08a5a;
}

/* ========= AMOR ========= */

.amor-box{
  margin-top:-42px;
}

.amor-title{
  font-family:'Playfair Display', serif;
  font-size:30px;
  color:#b08a5a;
}

.amor-text{
  margin-top:10px;

  font-family:'Playfair Display', serif;
  font-size:20px;
  line-height:1.8;

  color:#6f6660;
}

/* ========= CUENTA ========= */

.countdown-box{
  margin-top:34px;
}

.count-title{
  font-family:'Playfair Display', serif;
  font-size:30px;
  color:#b08a5a;
}

.count-grid{
  margin-top:16px;

  display:grid;
  grid-template-columns:repeat(4,1fr);

  gap:10px;
}
.hashtag-wrapper{
  position:relative;
  width:100%;
  z-index:30;
}
.count-item{
  background:rgba(255,255,255,.45);

  padding:14px 8px;

  border-radius:20px;

  backdrop-filter:blur(4px);
}

.count-number{
  display:block;

  font-family:'Playfair Display', serif;
  font-size:28px;

  color:#b08a5a;
}

.count-label{
  display:block;

  margin-top:4px;

  font-family:'Poppins', sans-serif;
  font-size:11px;

  color:#7c726b;

  text-transform:uppercase;

  letter-spacing:.08em;
}

/* ========= FOTO ========= */

.foto-box{
  margin-top:36px;

  display:flex;
  justify-content:center;
}

.foto-romantica{
  width:100%;
  max-width:100%;

  border-radius:28px;

  object-fit:cover;

  box-shadow:
  0 15px 40px rgba(0,0,0,.16);
}

/* ========= SEPARADORES ========= */

.separator-holder{
  display:flex;
  justify-content:center;

  margin:14px 0;
}

.separator-holder.mini{
  margin:10px 0;
}

.separador-img{
  width:80%;

  opacity:.9;
}

/* ========= RESPONSIVE ========= */

@media(max-width:768px){

  .evento-wrapper{
    padding:70px 18px;
  }

  .titulo-evento{
    font-size:32px;
  }

  .lugar{
    font-size:18px;
  }

  .hora{
    font-size:26px;
  }

  .cuenta-title{
    font-size:24px;
  }

  .cuenta-numero{
    font-size:18px;
  }

  .consideraciones-title,
  .amor-title,
  .count-title{
    font-size:27px;
  }

  .consideraciones-text,
  .amor-text{
    font-size:17px;
  }

  .solo-adultos{
    font-size:22px;
  }

  .count-number{
    font-size:22px;
  }

}

</style>